import getFetchOptions from 'utils/getFetchOptions';

import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

export default async function logout(hasSeenNotification) {
	try {
		const response = await fetch(
			`${ENDPOINT_URL}/logout`,
			getFetchOptions({
				method: 'POST',
				body: JSON.stringify({hasSeenNotification}),
			})
		);

		if (!response.ok) {
			throw response;
		}

		const data = await response.json();

		localStorage.removeItem('authtoken');
		window.location.href = data.redirect;

		return true;
	} catch (err) {
		return Promise.reject(apiErrorHandling(err));
	}
}
